import { InputAdornment, MenuItem, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import React from 'react';

const AppInputSearchMenuItem: React.FC<IAppInputSearchMenuItem> = ({ onSearch }) => {
    return (
        <MenuItem disableRipple disableTouchRipple style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
            <TextField
                size="small"
                fullWidth
                placeholder="Search..."
                onChange={(e) => onSearch(e.target.value)}
                variant="outlined"
                slotProps={{
                    input: {
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    },
                }}
            />
        </MenuItem>
    );
};

export { AppInputSearchMenuItem };
